import httpRequest from '../utils/httpRequest';

export function getWebRequest(date, lastSunday) {
    if (lastSunday)
        return httpRequest(`/web?lastMonday=${date}&lastSunday=${lastSunday}`, 'get');
    if (date)
        return httpRequest(`/web?date=${date}`, 'get');
    return httpRequest(`/web`, 'get');
}